export default "__VITE_ASSET__ChhqbhOh__"